var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.697 448H72.7563C67.9423 447.988 64.0422 444.089 64.0312 439.275V72.725C64.0432 67.911 67.9423 64.011 72.7563 64H170.697C188.37 64 202.697 49.673 202.697 32C202.697 14.327 188.37 0 170.697 0H72.7563C32.6103 0.047 0.07825 32.58 0.03125 72.725V439.274C0.07825 479.42 32.6103 511.953 72.7563 512H170.697C188.37 512 202.697 497.673 202.697 480C202.697 462.327 188.37 448 170.697 448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.913 188.117L401.097 105.365C388.596 92.8701 368.333 92.8751 355.838 105.376C343.343 117.877 343.348 138.14 355.849 150.635L428.638 223.403L138.697 224C121.024 224 106.697 238.327 106.697 256C106.697 273.673 121.024 288 138.697 288L429.812 287.467L355.849 361.43C343.807 374.366 344.532 394.614 357.467 406.656C369.762 418.101 388.813 418.092 401.097 406.635L483.849 323.883C521.34 286.393 521.34 225.609 483.85 188.119L483.849 188.118L483.913 188.117Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/log out.bcb6d1924cecc7bf08217d88066dc5a8.svg";
export { ForwardRef as ReactComponent };